module.exports = __webpack_public_path__ + "img/material-kid-sm.363b3576.png";